// extracted by mini-css-extract-plugin
export var absoluteSubmit = "productCard-module--absoluteSubmit--Fu4iP";
export var actions = "productCard-module--actions--V3Ni1";
export var chevron = "productCard-module--chevron--2N5BS";
export var focusVisible = "productCard-module--focus-visible--nbfqu";
export var hsErrorMsg = "productCard-module--hs-error-msg--q3Q8J";
export var hs_submit = "productCard-module--hs_submit--ElMAt";
export var icon = "productCard-module--icon--mRDdV";
export var input = "productCard-module--input--MaIe2";
export var productCard = "productCard-module--productCard--kEo2d";
export var productCard__content = "productCard-module--productCard__content--kO-SK";
export var productCard__img = "productCard-module--productCard__img--f3UnP";